import {defineStore} from 'pinia';

const DEFAULT_VEHICLE = 'truck_05';

export const useDeliveryStore = defineStore('deliveryStore', {
    state: () => ({
        address: '',
        coords: null,

        center: [55.462540, 37.781900],

        zone: {id: 1, name: 'Зона 1'},
        out_of_zones: false,
        distance_km: null,

        zones: [
            {id: 1, name: 'Зона 1', from_km: 0, to_km: 10},
            {id: 2, name: 'Зона 2', from_km: 10, to_km: 25},
            {id: 3, name: 'Зона 3', from_km: 25, to_km: 45},
            {id: 4, name: 'Зона 4', from_km: 45, to_km: 70},
            {id: 5, name: 'Зона 5', from_km: 70, to_km: 100},
        ],

        vehicle: DEFAULT_VEHICLE,

        vehicles: [
            {id: 'truck_05', label: '0.5 т'},
            {id: 'truck_15', label: '1.5 т'},
            {id: 'truck_35', label: '3.5 т'},
            {id: 'truck_50', label: '5 т'},
            {id: 'truck_75', label: '7.5 т'},
            {id: 'manipulator_75', label: 'Манипулятор 7.5 т'},
            {id: 'mixer', label: 'Бетономешалка'},
        ],

        intervals: [
            {id: 'interval_8h', label: 'Интервал 8 часов'},
            {id: 'interval_4h', label: 'Интервал 4 часа'},
            {id: 'interval_2h', label: 'Интервал 2 часа'},
            {id: 'exact', label: 'Точно ко времени'},
        ],

        /**
         * Заполняешь цены тут.
         *
         * vehicle_id: {
         *   zone_id: {
         *     interval_id: price
         *   }
         * }
         */
        prices: {
            truck_05: {
                1: {interval_8h: 1379, interval_4h: 1999, interval_2h: 2429, exact: 3359},
                2: {interval_8h: 1379, interval_4h: 1999, interval_2h: 2419, exact: 3339},
                3: {interval_8h: 1479, interval_4h: 2119, interval_2h: 2549, exact: 3529},
                4: {interval_8h: 1669, interval_4h: 2379, interval_2h: 2869, exact: 3959},
                5: {interval_8h: 2179, interval_4h: 3139, interval_2h: 4209, exact: 5259},
            },

            truck_15: {
                1: {interval_8h: 1999, interval_4h: 2859, interval_2h: 3919, exact: 4789},
                2: {interval_8h: 1779, interval_4h: 2549, interval_2h: 3419, exact: 4289},
                3: {interval_8h: 1919, interval_4h: 2689, interval_2h: 3599, exact: 4539},
                4: {interval_8h: 2159, interval_4h: 3029, interval_2h: 4049, exact: 5069},
                5: {interval_8h: 3089, interval_4h: 4459, interval_2h: 5969, exact: 7459},
            },

            truck_35: {
                1: {interval_8h: 3429, interval_4h: 4929, interval_2h: 5939, exact: 8249},
                2: {interval_8h: 3319, interval_4h: 4779, interval_2h: 5759, exact: 7969},
                3: {interval_8h: 3579, interval_4h: 5039, interval_2h: 6069, exact: 8419},
                4: {interval_8h: 4039, interval_4h: 5659, interval_2h: 6809, exact: 9429},
                5: {interval_8h: 4849, interval_4h: 6969, interval_2h: 9329, exact: 11679},
            },

            truck_50: {
                1: {interval_8h: 6339, interval_4h: 9099, interval_2h: 10959, exact: 15239},
                2: {interval_8h: 5349, interval_4h: 7649, interval_2h: 9239, exact: 12859},
                3: {interval_8h: 5769, interval_4h: 8049, interval_2h: 9719, exact: 13509},
                4: {interval_8h: 6489, interval_4h: 9039, interval_2h: 10919, exact: 15199},
                5: {interval_8h: 7839, interval_4h: 11219, interval_2h: 15039, exact: 18849},
            },

            truck_75: {
                1: {interval_8h: 9399, interval_4h: 13439, interval_2h: 16229, exact: 22609},
                2: {interval_8h: 8549, interval_4h: 12249, interval_2h: 14779, exact: 20569},
                3: {interval_8h: 9209, interval_4h: 12879, interval_2h: 15539, exact: 21629},
                4: {interval_8h: 10359, interval_4h: 14479, interval_2h: 17459, exact: 24309},
                5: {interval_8h: 12559, interval_4h: 17979, interval_2h: 24079, exact: 30169},
            },

            manipulator_75: {
                1: {interval_8h: 9399, interval_4h: 13439, interval_2h: 16229, exact: 22609},
                2: {interval_8h: 8549, interval_4h: 12249, interval_2h: 14779, exact: 20569},
                3: {interval_8h: 9209, interval_4h: 12879, interval_2h: 15539, exact: 21629},
                4: {interval_8h: 10359, interval_4h: 14479, interval_2h: 17459, exact: 24309},
                5: {interval_8h: 12559, interval_4h: 17979, interval_2h: 24079, exact: 30169},
            },

            mixer: {
                1: {interval_8h: 11279, interval_4h: 16129, interval_2h: 19479, exact: 27129},
                2: {interval_8h: 10259, interval_4h: 14699, interval_2h: 17729, exact: 24679},
                3: {interval_8h: 11049, interval_4h: 15449, interval_2h: 18649, exact: 25959},
                4: {interval_8h: 12429, interval_4h: 17369, interval_2h: 20949, exact: 29169},
                5: {interval_8h: 15069, interval_4h: 21579, interval_2h: 28889, exact: 36199},
            },
        },
    }),

    getters: {
        selectedVehicle(state) {
            return state.vehicles.find(v => v.id === state.vehicle) ?? null;
        },

        currentPrices(state) {
            if (state.out_of_zones) return [];

            const zoneId = state.zone?.id;
            const vehicleId = state.vehicle;

            return state.intervals
                .map(interval => ({
                    ...interval,
                    price: state.prices?.[vehicleId]?.[zoneId]?.[interval.id] ?? null,
                }))
                .filter(item => item.price !== null && item.price !== undefined);
        },
    },

    actions: {
        setAddress(address) {
            this.address = address;
        },

        setVehicle(vehicleId) {
            this.vehicle = vehicleId;
        },

        setZone(zone) {
            this.zone = zone || {id: 1, name: 'Зона 1'};
        },

        setCenter(center) {
            if (Array.isArray(center) && center.length === 2) {
                this.center = center;
            }
        },

        setCoords(coords) {
            this.coords = coords;
            this.updateZoneByCoords();
        },

        haversineKm([lat1, lon1], [lat2, lon2]) {
            const toRad = value => value * Math.PI / 180;
            const R = 6371;

            const dLat = toRad(lat2 - lat1);
            const dLon = toRad(lon2 - lon1);

            const a =
                Math.sin(dLat / 2) ** 2 +
                Math.cos(toRad(lat1)) *
                Math.cos(toRad(lat2)) *
                Math.sin(dLon / 2) ** 2;

            return 2 * R * Math.asin(Math.sqrt(a));
        },

        updateZoneByCoords() {
            if (!Array.isArray(this.coords) || this.coords.length !== 2) return;

            const distance = this.haversineKm(this.center, this.coords);
            this.distance_km = Number(distance.toFixed(1));

            const foundZone = this.zones.find(zone => {
                return distance >= zone.from_km && distance < zone.to_km;
            });

            if (foundZone) {
                this.out_of_zones = false;
                this.setZone(foundZone);
                return;
            }

            const lastZone = this.zones[this.zones.length - 1];

            this.out_of_zones = true;
            this.setZone({
                id: 'beyond',
                name: 'За зоной',
                from_km: lastZone.to_km,
                to_km: Infinity,
            });
        },
    },
});
